import { Box, Col, Icon, Link, Row } from '@digitools/honest-react';
import useTranslate from 'src/hooks/useTranslate';
import DentalText from 'src/packages/dental/constants/DentalText';
import React from 'react';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import useDentalDataContext from 'src/packages/dental/hooks/useDentalContext';
import { DentalSubHeading } from 'src/packages/dental/Dental';
import { useMediaQuery } from '@mantine/hooks';
const AdditionalResources = () => {
    const { tealiumFunction } = useDentalDataContext();
    const { t } = useTranslate();
    const isTitleView = useMediaQuery('(max-width: 780px)');
    const AdditionalResourcesBox = ({ link, eventName, children, text, iconName, iconSize }) => {
        return (<Col md={6} className={'mb-2'}>
        <Box className={iconSize ? 'h-100 pt-2' : 'h-100'} borderType={'rounded'}>
          <Icon className={iconSize ? 'pr-2 mt-1' : 'pr-2'} size={iconSize || 'small'} name={iconName || 'documents'} color={'secondaryDark'}/>
          <Link aria-describedby={`${eventName.replace(' ', '-')}-text`} href={link} target={'_blank'} onClick={() => {
                tealiumFunction({
                    eventAction: TEALIUM_EVENT.EVENT_ACTION.LINK,
                    eventName: eventName,
                    memberEvent: 'Additional resources',
                });
            }}>
            {children}
          </Link>
          <p style={{ marginTop: iconSize ? '1rem' : '1.1rem' }} id={`${eventName.replace(' ', '-')}-text`}>{text}</p>
        </Box>
      </Col>);
    };
    return (<Row data-public={true}>
      <Col md={12} className={'mb-2'}>
        <Row>
          <Col md={12}>
            <DentalSubHeading isTitleView={isTitleView} text={t(DentalText.additionalResources)}/>
          </Col>
        </Row>
        <Row>
          <AdditionalResourcesBox eventName={'Forms'} link={'https://www.lincoln4benefits.com/jpfebill/forms/gfrmsel2.asp'} text={t(DentalText.formsInformation)}>
            {t(DentalText.additionalResourcesForms)}
          </AdditionalResourcesBox>
          <AdditionalResourcesBox iconSize={'medium'} iconName={'switch-personal'} eventName={'Lincoln DentalConnect'} link={'https://ohl.go2dental.com/?cli=lincoln&sec=y&_cmatype=open'} text={t(DentalText.dentalConnectInformation)}>
            <em>Lincoln DentalConnect</em>
            <sup>®</sup>
          </AdditionalResourcesBox>
        </Row>
      </Col>
    </Row>);
};
export default AdditionalResources;
